import  { useState, useEffect } from "react";
import { db } from "../firebase/firebase-config";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";

const MyAmount = () => {
  const [records, setRecords] = useState([]);
  const [form, setForm] = useState({
    name: "",
    mobileNumber: "",
    principalAmount: "",
    interestRate: "",
    amountTakeDate: "",
  });
  const [showForm, setShowForm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const collectionRef = collection(db, "my-amount");

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const querySnapshot = await getDocs(collectionRef);
        const records = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setRecords(records);
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    };

    fetchRecords();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (isEditMode) {
      try {
        const docRef = doc(db, "my-amount", currentId);
        await updateDoc(docRef, form);
        setRecords((prevRecords) =>
          prevRecords.map((record) =>
            record.id === currentId ? { ...record, ...form } : record
          )
        );
        setIsEditMode(false);
        setCurrentId(null);
      } catch (error) {
        console.error("Error updating record:", error);
      }
    } else {
      try {
        const docRef = await addDoc(collectionRef, {
          ...form,
          createDate: new Date().toISOString(),
        });
        setRecords((prevRecords) => [
          ...prevRecords,
          { ...form, id: docRef.id, createDate: new Date().toISOString() },
        ]);
      } catch (error) {
        console.error("Error adding record:", error);
      }
    }

    setForm({
      name: "",
      mobileNumber: "",
      principalAmount: "",
      interestRate: "",
      amountTakeDate: "",
    });
    setShowForm(false);
  };

  const handleEdit = (record) => {
    setForm(record);
    setCurrentId(record.id);
    setIsEditMode(true);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    try {
      const docRef = doc(db, "my-amount", id);
      await deleteDoc(docRef);
      setRecords((prevRecords) =>
        prevRecords.filter((record) => record.id !== id)
      );
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  const getDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.floor((end - start) / (1000 * 3600 * 24));
  };

  const calculateInterest = (record) => {
    const amountTakeDate = new Date(record.amountTakeDate);
    const now = new Date();
    const totalDays = getDaysDifference(amountTakeDate, now);
    const tillNowInterest =
      (totalDays * record.principalAmount * record.interestRate) / (100 * 30);

    return {
      tillNowInterest: isNaN(tillNowInterest) ? 0 : Number(tillNowInterest),
      totalDays,
    };
  };

  const filteredRecords = records.filter((record) =>
    Object.values(record)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  // Calculate totals
  const totalPrincipal = filteredRecords.reduce(
    (sum, record) => sum + Number(record.principalAmount || 0),
    0
  );

  const totalInterest = filteredRecords.reduce((sum, record) => {
    const { tillNowInterest } = calculateInterest(record);
    return sum + Number(tillNowInterest);
  }, 0);

  const totalNetAmount = totalPrincipal + totalInterest;

  return (
    <div>
      <h2>My Amount Records</h2>

      

      {/* Search and Add */}
      <div className="d-flex mb-3">
        <button
          className="btn btn-primary me-3"
          onClick={() => {
            setForm({
              name: "",
              mobileNumber: "",
              principalAmount: "",
              interestRate: "",
              amountTakeDate: "",
            });
            setIsEditMode(false);
            setShowForm(true);
          }}
        >
          Add New Record
        </button>
        <input
          type="text"
          className="form-control"
          placeholder="Search by name or mobile number"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

     

      {/* Modal Form */}
      {showForm && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditMode ? "Edit Record" : "Add New Record"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowForm(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleFormSubmit}>
                  <div className="mb-3">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={form.name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Mobile Number</label>
                    <input
                      type="text"
                      name="mobileNumber"
                      className="form-control"
                      value={form.mobileNumber}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Principal Amount</label>
                    <input
                      type="number"
                      name="principalAmount"
                      className="form-control"
                      value={form.principalAmount}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Interest Rate</label>
                    <input
                      type="number"
                      name="interestRate"
                      className="form-control"
                      value={form.interestRate}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Amount Take Date</label>
                    <input
                      type="date"
                      name="amountTakeDate"
                      className="form-control"
                      value={form.amountTakeDate}
                      onChange={handleInputChange}
                    />
                  </div>
                  <button type="submit" className="btn btn-success">
                    {isEditMode ? "Update" : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      <table className="table table-striped">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Mobile Number</th>
            <th>Name</th>
            <th>Principal Amount</th>
            <th>Rate of Interest (%)</th>
            <th>Amount Take Date</th>
            <th>Days</th>
            <th>Till Now Interest</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredRecords.map((record, index) => {
            const { tillNowInterest, totalDays } = calculateInterest(record);
            return (
              <tr key={record.id}>
                <td>{index + 1}</td>
                <td>{record.mobileNumber}</td>
                <td>{record.name}</td>
                <td>{record.principalAmount}</td>
                <td>{record.interestRate}</td>
                <td>{record.amountTakeDate}</td>
                <td>{totalDays} days</td>
                <td>{tillNowInterest.toFixed(2)}</td>
                <td>
                  <button
                    className="btn btn-warning me-2"
                    onClick={() => handleEdit(record)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleDelete(record.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

       {/* Totals Card */}
      <div className="card p-3 mb-4 shadow-sm" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="d-flex justify-content-around">
          <div>
            <h5>Total Principal</h5>
            <p className="fw-bold text-primary">₹ {totalPrincipal.toFixed(2)}</p>
          </div>
          <div>
            <h5>Total Interest</h5>
            <p className="fw-bold text-success">₹ {totalInterest.toFixed(2)}</p>
          </div>
          <div>
            <h5>Total Net Amount</h5>
            <p className="fw-bold text-danger">₹ {totalNetAmount.toFixed(2)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAmount;
